var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video_button"},[_c('primary-button',{attrs:{"link":false,"label":_vm.label,"type":'video'},nativeOn:{"click":function($event){return _vm.openVideoModal.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/VideoButton.vue